import React from "react";
import Spinner from "react-bootstrap/Spinner";
import "./Loader.css";
export const Loader = () => {
	// const imgArray = ["study", "skipping", "dog-tail"];
	// const randomIndex = Math.floor(Math.random() * imgArray.length);
	// const randomElement = "loader " + imgArray[randomIndex];
	return (
		<div className="overlay">
			<div className="loader">
				<Spinner animation="border" size="sm" />
				&nbsp; Loading...
			</div>
		</div>
	);
};
